/**
 * ========================================
 * 
 * Main Javascript File 
 * 
 * ========================================
 */

// Styles
import '../scss/main.scss';

// Images
import '../img/spinner.gif';
import '../img/angle.svg';
import '../img/heart-solid.svg';
import '../img/heart-outline.svg';

// Scripts
import './automatic.js';
import './interaction.js';
import './sizing-spacing.js';